
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/content/[...params]",
      function () {
        return require("private-next-pages/blog/content/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/content/[...params]"])
      });
    }
  